import Grid from '@material-ui/core/Grid';
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { useCookies } from 'react-cookie';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import TableHeaderFilter from '../../Common/TableHeaderFilter';
import TableContainer from '@material-ui/core/TableContainer';
import { Checkbox, Table } from '@material-ui/core';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useHistory } from 'react-router-dom';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import { getQuery } from '../../../utils/common';
import {
    ACTIVE,
    DECLINED,
    SUSPENDED
} from '../../../utils/constants';
import { ROWS_PER_PAGE, UsersTab } from '../../../constants';
import {
    DeleteUser,
    GetUsersList,
    UpdateUserPermission,
    UpdateUserProfile
} from '../../../redux/Users/actions';
import {
    AFFILIATED_MODAL,
    CHANGE_PASSWORD_MODAL,
    CHANGE_USER_EMAIL_MODAL,
    FIRM_LIST_MODAL,
    OPEN_ALERT_MODAL,
    SESSIONS_MODAL
} from '../../../redux/ModalReducer/actionTypes';
import { OpenAlert } from '../Common';
import { renderUserMenuItems } from '../Common/UserMenuItems';
import { OpenModal } from '../../../redux/Common/action';
import TableCells from '../TableCells';
import { CommonTableStyle } from '../../Common/CommonTableStyle';
import { CommonPaginationAction } from '../Common/CommonPaginationAction';
import { useLocation } from 'react-router-dom';
import { showSnackbar } from '../../../utils/snackbar';
import { useTenant } from '../../../utils/tenant';

const ActiveComponent = ({
    sectionBaseUrl,
    isMainFilterApplied,
    getAllTabsData,
    GetUsersList,
    UpdateUserProfile,
    UpdateUserPermission,
    OpenModal,
    DeleteUser,
    loading
}: any) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const filterParam = searchParams.get('filter');
    let decodedFilters;
    if (filterParam) {
        decodedFilters = JSON.parse(decodeURIComponent(filterParam));
    }
    const [selectedRows, setSelectedRows] = useState<number[]>([]);
    const [selectedAll, setSelectedAll] = useState<any>(false);
    const classes = CommonTableStyle();
    const [isLoading, setIsLoading] = useState(false);
    const [isFilterApplied, setIsFilterApplied] = useState(isMainFilterApplied);
    const [selectedUser, setSelectedUser] = useState({});
    const tableHeader = useSelector(
        (store: RootState) => store?.users.tableHeader || []
    );
    const listingsData = useSelector(
        (store: RootState) => store?.users.activeUsersList
    );
    const [cookies] = useCookies(['pgAdminToken']);
    const token = cookies['pgAdminToken'];
    const { getUserUrl } = useTenant();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const history = useHistory();
    const query = getQuery(history);
    const type = query.get('type');
    const keyword = query.get('keyword');
    const [page, setPage] = useState(0);
    const count = listingsData?.count;
    const total_pages = listingsData?.total_pages;

    useEffect(() => {
        if (
            !isFilterApplied &&
            (keyword || type || typeof page !== 'undefined')
        ) {
            getData({
                filter: decodedFilters,
                keyword,
                type,
                page: page + 1,
                tab: UsersTab.TYPE_ACTIVE
            });
        }
        // eslint-disable-next-line
    }, [keyword, type, page]);

    const handleClick = (event: React.MouseEvent<HTMLElement>, user) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
        setSelectedUser(user);
    };

    const handleClose = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorEl(null);
    };

    const getData = (data) => {
        data.size = ROWS_PER_PAGE;
        setIsLoading(true);
        GetUsersList(token, data).then(() => {
            setIsLoading(false);
            OpenModal(OPEN_ALERT_MODAL, { isOpen: false });
        });
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
        setIsFilterApplied(false);
    };

    const CommonComponent = () => (
        <CommonPaginationAction
            count={count}
            page={page}
            setPage={setPage}
            total_pages={total_pages}
        />
    );

    const handleChange = (value, selectedUser) => {
        switch (value) {
            case 'profile':
                const url = getUserUrl(selectedUser?.user_name);
                window.open(url, '_blank');
                break;
            case 'editUser':
                history.push(`/users/edit-user/${selectedUser?.user_id}`);
                break;
            case 'editStrategy':
                history.push(`/users/edit-strategy/${selectedUser?.user_id}`);
                break;
            case 'firmListModal':
                OpenModal(FIRM_LIST_MODAL, {
                    isOpen: true,
                    title: `User Settings for ${selectedUser?.full_name}`,
                    data: { selectedUser, page, tab: UsersTab.TYPE_ACTIVE },
                    callBack: () => {
                        GetUsersList(token, { keyword, type, page });
                    }
                });
                break;
            case 'userSessions':
                OpenModal(SESSIONS_MODAL, {
                    title: 'User Sessions',
                    isOpen: true,
                    data: { selectedUser }
                });
                break;

            case 'changePassword':
                OpenModal(CHANGE_PASSWORD_MODAL, {
                    title: 'Change Password',
                    isOpen: true,
                    data: { selectedUser }
                });
                break;
            case 'changeEmail':
                OpenModal(CHANGE_USER_EMAIL_MODAL, {
                    title: 'Change Email',
                    isOpen: true,
                    data: { selectedUser },
                    getData
                });
                break;
            case 'Affiliated':
                OpenModal(AFFILIATED_MODAL, {
                    title: 'Add Affiliation',
                    isOpen: true,
                    data: { selectedUser }
                });
                break;
            case 'approve':
                OpenAlert({
                    title: 'Approve',
                    description: 'Are you sure you want to approve this user?',
                    submitTitle: 'Approve',
                    token,
                    payload: {
                        user_id: selectedUser?.user_id,
                        admin_status: ACTIVE
                    },
                    tab: UsersTab.TYPE_ACTIVE,
                    OpenModal,
                    UpdateUserProfile,
                    getData: getAllTabsData,
                    keyword,
                    type,
                    page
                });
                break;
            case 'decline':
                OpenAlert({
                    title: 'Decline',
                    description: 'Are you sure you want to decline this user?',
                    submitTitle: 'Decline',
                    token,
                    payload: {
                        user_id: selectedUser?.user_id,
                        admin_status: DECLINED
                    },
                    tab: UsersTab.TYPE_ACTIVE,
                    OpenModal,
                    UpdateUserProfile,
                    getData: getAllTabsData,
                    keyword,
                    type,
                    page
                });
                break;
            case 'suspend':
                OpenAlert({
                    title: 'Suspend',
                    description: 'Are you sure you want to Suspend this user?',
                    submitTitle: 'Suspend',
                    token,
                    payload: {
                        user_id: selectedUser?.user_id,
                        admin_status: SUSPENDED
                    },
                    tab: UsersTab.TYPE_ACTIVE,
                    OpenModal,
                    UpdateUserProfile,
                    getData: getAllTabsData,
                    keyword,
                    type,
                    page
                });
                break;
            case 'delete':
                OpenModal(OPEN_ALERT_MODAL, {
                    isOpen: true,
                    title: 'Delete User',
                    description: 'Are you sure you want to delete this user?',
                    submitTitle: 'Delete',
                    isDelete: true,
                    data: { disableBackdropClick: true },
                    callBack: () => {
                        DeleteUser(token, selectedUser?.user_id)
                            .then(() => {
                                OpenModal(OPEN_ALERT_MODAL, {
                                    isOpen: false
                                });
                                getAllTabsData({
                                    keyword,
                                    type,
                                    page,
                                    tab: UsersTab.TYPE_ACTIVE
                                });
                            })
                            .catch(() => {
                                OpenModal(OPEN_ALERT_MODAL, {
                                    isOpen: false
                                });
                                showSnackbar('Something went wrong.');
                            });
                    }
                });
                break;
        }
    };

    const renderMenu = (_, __, row) => {
        return (
            <>
                <IconButton
                    aria-label="more"
                    aria-controls="long-menu"
                    aria-haspopup="true"
                    onClick={(e) => handleClick(e, row)}
                >
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={open}
                    onClose={handleClose}
                    elevation={0}
                    PaperProps={{
                        style: {
                            // maxHeight: ITEM_HEIGHT * 4.5,
                            width: '20ch',
                            border: '1px solid rgb(0 106 194 / 20%)'
                        }
                    }}
                >
                    {renderUserMenuItems({
                        selectedUser,
                        onSelect: (value) => {
                            handleChange(value, selectedUser);
                            setAnchorEl(null);
                        }
                    })}
                </Menu>
            </>
        );
    };

    const handleVerify = (payload, type) => {
        OpenAlert({
            title: `Verify ${type === 'EMAIL' ? 'Email' : 'Phone'}`,
            description: `Are you sure you want to verify ${
                type === 'EMAIL' ? 'email' : 'phone'
            }?`,
            submitTitle: 'Verify',
            token,
            payload,
            OpenModal,
            UpdateUserProfile,
            getData,
            keyword,
            type,
            page,
            tab: UsersTab.TYPE_ACTIVE
        });
    };

    const handleStoryPost = (allow_story_post, user_id) => {
        if (allow_story_post !== null) {
            OpenAlert({
                title: `${
                    allow_story_post ? 'Activate' : 'Deactivate'
                } Post Stories`,
                description: `Are you sure you want to ${
                    allow_story_post ? 'Activate' : 'Deactivate'
                } Post Stories for this user?`,
                submitTitle: `${allow_story_post ? 'Activate' : 'Deactivate'}`,
                token,
                payload: {
                    user_id,
                    allow_story_post
                },
                OpenModal,
                UpdateUserProfile,
                getData,
                keyword,
                type,
                page,
                tab: UsersTab.TYPE_ACTIVE
            });
        }
    };

    const handleCommonUpdater = ({
        title,
        description,
        submitTitle,
        payload
    }) => {
        OpenModal(OPEN_ALERT_MODAL, {
            isOpen: true,
            title,
            description,
            data: { disableBackdropClick: true },
            submitTitle,
            cancelTitle: 'No',
            callBack: () => {
                UpdateUserPermission(token, payload)
                    .then(() =>
                        getData({
                            keyword,
                            type,
                            page: page + 1,
                            tab: UsersTab.TYPE_ACTIVE
                        })
                    )
                    .catch(() => {
                        OpenModal(OPEN_ALERT_MODAL, { isOpen: false });
                    });
            }
        });
    };
    const handleSelectAllClick = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setSelectedAll(event.target.checked);
        if (event.target.checked) {
            const newSelecteds = listingsData?.posts.map((row) => row.user_id);
            setSelectedRows(newSelecteds);
            return;
        } else {
            setSelectedRows([]);
        }
    };
    return (
        <Grid container spacing={0} className="h-100">
            <Grid item xs={12}>
                <Paper className={classes.root}>
                    <TableHeaderFilter
                        sectionBaseUrl={sectionBaseUrl}
                        userIds={selectedAll ? [] : selectedRows}
                        selectAll={selectedAll}
                        setSelectedRows={(data) => setSelectedRows(data)}
                    />
                    {loading || isLoading ? (
                        <div className="mainLoader">
                            <div className="loader" />
                        </div>
                    ) : (
                        <>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {tableHeader?.map((column) => (
                                                <TableCell key={column.id}>
                                                    {column.id ===
                                                    'selection' ? (
                                                        <Checkbox
                                                            indeterminate={
                                                                selectedRows.length >
                                                                    0 &&
                                                                selectedRows.length <
                                                                    listingsData
                                                                        ?.posts
                                                                        .length
                                                            }
                                                            checked={
                                                                selectedAll
                                                            }
                                                            onChange={
                                                                handleSelectAllClick
                                                            }
                                                        />
                                                    ) : (
                                                        column.label
                                                    )}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {listingsData?.posts &&
                                        listingsData?.posts.length ? (
                                            listingsData?.posts?.map((row) => {
                                                return (
                                                    <TableRow
                                                        hover
                                                        role="checkbox"
                                                        tabIndex={-1}
                                                        key={row?.user_id}
                                                        style={{
                                                            padding: 0,
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={() => {
                                                            history.push(
                                                                `/users/view/${row?.user_id}`
                                                            );
                                                        }}
                                                    >
                                                        <TableCells
                                                            row={row}
                                                            renderMenu={
                                                                renderMenu
                                                            }
                                                            handleVerify={
                                                                handleVerify
                                                            }
                                                            handleCommonUpdater={
                                                                handleCommonUpdater
                                                            }
                                                            handleStoryPost={
                                                                handleStoryPost
                                                            }
                                                            selectedRows={
                                                                selectedRows
                                                            }
                                                            setSelectedRows={(
                                                                data
                                                            ) =>
                                                                setSelectedRows(
                                                                    data
                                                                )
                                                            }
                                                            selectedAll={
                                                                selectedAll
                                                            }
                                                        />
                                                    </TableRow>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan={
                                                        tableHeader.length + 1
                                                    }
                                                    className="dataNotAvailable"
                                                >
                                                    Data not available
                                                </td>
                                            </tr>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                className={classes.footer}
                                hidden={
                                    listingsData?.posts &&
                                    !listingsData?.posts.length
                                }
                                rowsPerPageOptions={[]}
                                component="div"
                                count={count}
                                rowsPerPage={listingsData?.page_size}
                                page={page}
                                ActionsComponent={CommonComponent}
                                onPageChange={handleChangePage}
                            />
                        </>
                    )}
                </Paper>
            </Grid>
        </Grid>
    );
};
export default connect(null, {
    GetUsersList,
    UpdateUserProfile,
    OpenModal,
    UpdateUserPermission,
    DeleteUser
})(ActiveComponent);
